import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {useStore} from "../../../hooks/useStore";

const PoolCourierShiftSelectionCountFilter = ({
    value,
    onChange,
    showLabel = true,
    showAllOption = true,
    mode = undefined,
    selectMarginBottom = "20px",
    allowClear = false,
    showSearch = false
}) => {
    const {t} = useTranslation();
    const stores = useStore();
    return (
        <React.Fragment>
            {showLabel && <h5>{"Kurye Vardiya Seçim"}</h5>}
            <SelectField
                showSearch={showSearch}
                value={value}
                data-testid="pool_courier_shift_selection_select"
                mode={mode}
                onChange={onChange}
                mb={selectMarginBottom}
                allowClear={allowClear}
            >
                {showAllOption ? (
                    <SelectField.Option
                        data-testid="pool_courier_shift_selection_option"
                        value={"all"}
                    >
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                ) : (
                    <></>
                )}
                <SelectField.Option
                    data-testid="pool_courier_shift_selection_option"
                    value={"atLeastOneShiftGeneral"}
                >
                    Genel En Az Bir Vardiya Seçmişler
                </SelectField.Option>
                <SelectField.Option
                    data-testid="pool_courier_shift_selection_option"
                    value={"atLeastOneShiftThisPool"}
                >
                    Bu Havuzda En Az Bir Vardiya Seçmişler
                </SelectField.Option>
                <SelectField.Option
                    data-testid="pool_courier_shift_selection_option"
                    value={"noShiftGeneral"}
                >
                    Genel Vardiya Seçmemişler
                </SelectField.Option>
                <SelectField.Option
                    data-testid="pool_courier_shift_selection_option"
                    value={"noShiftThisPool"}
                >
                    Bu Havuzda Vardiya Seçmemişler
                </SelectField.Option>
            </SelectField>
        </React.Fragment>
    );
};

export default PoolCourierShiftSelectionCountFilter;
